import * as React from 'react'

import { connect } from 'react-redux'

import { communicationToLoadableProps } from '../../project-utils'
import {
  ApplicationState,
  experienceEditRequest,
  experienceGetRequest,
  selectExperience,
}                                       from '../../redux'
import { ExperienceType }               from '../../types'
import { ExperienceEditForm }           from '../forms'

const mstp = (state: ApplicationState) =>
  ({
    experienceGetCommunication:  experienceGetRequest.communicationSelector(state),
    experienceEditCommunication: experienceEditRequest.communicationSelector(state),
    experience:                  selectExperience(state),
  })

const actions = {
  getExperience:  experienceGetRequest.actionCreator,
  editExperience: experienceEditRequest.actionCreator,
}

interface EditPersonalInformationProps {
  experienceType: ExperienceType
}

type Props =
  EditPersonalInformationProps
  & ReturnType<typeof mstp>
  & typeof actions

class EditPersonalInformation extends React.Component<Props> {
  public componentDidMount () {
    this.props.getExperience()
  }

  public render () {
    const {
      experienceGetCommunication,
      experienceEditCommunication,
      experience,
    } = this.props

    return (
      <ExperienceEditForm
        key={experience && experience.length}
        isCached={experience instanceof Array}
        onSubmit={this.handleSubmit}
        values={{ experiences: experience }}
        {...communicationToLoadableProps(experienceGetCommunication)}
        {...experienceEditCommunication}
      />
    )
  }

  private handleSubmit = values => {
    const { editExperience, experienceType } = this.props

    editExperience(experienceType, values)
  }
}

export default connect(
  mstp,
  actions,
)(EditPersonalInformation)



// WEBPACK FOOTER //
// ./src/components/environments/EditExperience.tsx